import { Html, useProgress } from "@react-three/drei";

export const CanvasLaoder = () => {
  const progress = useProgress();
  return <Html>{progress.progress.toFixed(2)}%</Html>;
};
